import style from "./GridPageLayout.module.css";

type GridPageLayoutProps = {
  children: React.ReactNode;
  banner?: React.ReactNode;
};

export const GridPageLayout = ({ children, banner }: GridPageLayoutProps) => {
  // Always render the same tree shape so `children` keep a stable position in
  // the React tree. Branching on `banner` (returning the grid bare vs. nested
  // in a wrapper) moved children to a different parent when the banner toggled,
  // which remounted them and reset their local state (e.g. the deposit
  // MethodList's selected payment method jumping back to the first item).
  // `banner` renders nothing when falsy, so no-banner pages add no extra DOM
  // beyond the layout-neutral wrapper.
  return (
    <div className={style["grid-page-layout-wrapper"]}>
      {banner}
      <div className={`${style["grid-page-layout"]}`}>{children}</div>
    </div>
  );
};
